import { jsxs as y, jsx as d } from "react/jsx-runtime";
import { fpds as m } from "@ucl/shared-component-foundations/foundations";
import u, { css as b } from "styled-components";
import E, { createContext as x, Component as k, createElement as h } from "react";
import { u as v } from "./PageContext-57b2437f.js";
import "@adobe/aem-spa-page-model-manager";
import { g as w } from "./component-a7888ba1.js";
import "html-react-parser";
import "sanitize-html";
const C = [
  "development",
  "dev",
  "local",
  "test"
].includes(process.env.NODE_ENV || "") || typeof window < "u" && window.location.href.includes("localhost"), B = /* @__PURE__ */ u.div.withConfig({
  displayName: "defaultFallbackRenderer__ErrorContainer",
  componentId: "sc-f8bbd183-0"
})([
  "display:inline-block;padding:1rem;background:#f1f1f1;border-radius:5px;margin:1rem;border:1px solid #e5e5e5;"
]), g = /* @__PURE__ */ u.p.withConfig({
  displayName: "defaultFallbackRenderer__Text",
  componentId: "sc-f8bbd183-1"
})(() => /* @__PURE__ */ b({
  margin: "0px",
  letterSpacing: "0px",
  color: m.semantic.color.text.default,
  ...m.semantic.typography.body.regular.M
})), F = /* @__PURE__ */ u.p.withConfig({
  displayName: "defaultFallbackRenderer__Caption",
  componentId: "sc-f8bbd183-2"
})(() => /* @__PURE__ */ b({
  ...m.semantic.typography.body.regular.XS,
  minWidth: "max-content",
  textAlign: "left"
})), R = /* @__PURE__ */ u.code.withConfig({
  displayName: "defaultFallbackRenderer__Code",
  componentId: "sc-f8bbd183-3"
})([
  "display:inline-block;background-color:#1e1e1e;border:1px solid #dddddd;padding:0.9rem 1.2rem;white-space:nowrap;border-radius:5px;color:#ffffff;&::selection{color:#000000;background:#e4e4e4;}"
]);
function S({ error: a, resetErrorBoundary: e, componentName: r, ...o }) {
  if (console.error(r, a), console.log(`${r} Props: `, {
    componentName: r,
    ...o
  }), !C)
    return null;
  const t = `<${r} fallback={({error}) => <div>Place your Fallback Content here</div>} />`;
  return /* @__PURE__ */ y(B, {
    role: "alert",
    "data-component": r,
    children: [
      /* @__PURE__ */ d(g, {
        style: {
          color: "#bd0000",
          marginBottom: "0px"
        },
        children: "You are seeing this message because Something went Wrong!"
      }),
      /* @__PURE__ */ d(F, {
        children: "Please Check the console log for more detailed error"
      }),
      /* @__PURE__ */ d(g, {
        style: {
          color: "black",
          margin: "5px 0px 10px,10px",
          marginTop: "1rem"
        },
        children: "To replace this view, please use the following code:"
      }),
      /* @__PURE__ */ d(R, {
        children: t
      })
    ]
  });
}
const N = x(null), f = {
  didCatch: !1,
  error: null
};
class P extends k {
  constructor(e) {
    super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = f;
  }
  static getDerivedStateFromError(e) {
    return {
      didCatch: !0,
      error: e
    };
  }
  resetErrorBoundary() {
    const {
      error: e
    } = this.state;
    if (e !== null) {
      for (var r, o, t = arguments.length, l = new Array(t), n = 0; n < t; n++)
        l[n] = arguments[n];
      (r = (o = this.props).onReset) === null || r === void 0 || r.call(o, {
        args: l,
        reason: "imperative-api"
      }), this.setState(f);
    }
  }
  componentDidCatch(e, r) {
    var o, t;
    (o = (t = this.props).onError) === null || o === void 0 || o.call(t, e, r);
  }
  componentDidUpdate(e, r) {
    const {
      didCatch: o
    } = this.state, {
      resetKeys: t
    } = this.props;
    if (o && r.error !== null && D(e.resetKeys, t)) {
      var l, n;
      (l = (n = this.props).onReset) === null || l === void 0 || l.call(n, {
        next: t,
        prev: e.resetKeys,
        reason: "keys"
      }), this.setState(f);
    }
  }
  render() {
    const {
      children: e,
      fallbackRender: r,
      FallbackComponent: o,
      fallback: t
    } = this.props, {
      didCatch: l,
      error: n
    } = this.state;
    let i = e;
    if (l) {
      const s = {
        error: n,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof r == "function")
        i = r(s);
      else if (o)
        i = h(o, s);
      else if (t !== void 0)
        i = t;
      else
        throw n;
    }
    return h(N.Provider, {
      value: {
        didCatch: l,
        error: n,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, i);
  }
}
function D() {
  let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return a.length !== e.length || a.some((r, o) => !Object.is(r, e[o]));
}
function V(a) {
  const e = a.displayName || a.name, r = /* @__PURE__ */ E.forwardRef((o, t) => {
    const { editableFallback: l, noEditableFallback: n } = v(), { fallback: i = l, noFallback: s = n, ...c } = o;
    return s ? /* @__PURE__ */ d(a, {
      ...c
    }) : /* @__PURE__ */ d(P, {
      ...typeof i > "u" ? {
        fallbackRender: (p) => S({
          ...p,
          componentName: e,
          ...c
        })
      } : typeof i == "function" ? {
        fallbackRender: (p) => i({
          ...p,
          componentName: e,
          ...c
        })
      } : {
        fallback: i
      },
      children: /* @__PURE__ */ d(a, {
        ref: t,
        ...c
      })
    });
  });
  return r.displayName = `withErrorBoundary(${w(a)})`, r;
}
export {
  S as defaultFallbackRenderer,
  V as withErrorBoundary
};
